import { render, staticRenderFns } from "./KeyboardPro.vue?vue&type=template&id=f8e6ae04&scoped=true"
import script from "./KeyboardPro.vue?vue&type=script&lang=js"
export * from "./KeyboardPro.vue?vue&type=script&lang=js"
import style0 from "./KeyboardPro.vue?vue&type=style&index=0&id=f8e6ae04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e6ae04",
  null
  
)

export default component.exports